// src/pages/HomePage.jsx
import React from 'react';

import FeaturedSection from '../components/FeaturedSection';
import AboutPreview from '../components/AboutPreview';

// Images (adjust paths according to your project structure)
import Book11 from '../Images/new3.jpg';
//import Book11 from '../Images/Hero1.JPG';

// Assuming theme is exported from utils/constants.js
import { theme } from '../utils/constants';

export default function HomePage({ addToCart, navigateTo, books, accessories }) {
  const featuredBooks = books.slice(0, 3);
  const featuredAccessories = accessories.slice(0, 3);

  return (
    <>
       
       <section
  style={{
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    background: `
      linear-gradient(
        rgba(20,20,35,0.85),
        rgba(20,20,35,0.85)
      ),
      url(${Book11})
    `,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'white',
    textAlign: 'center',
    padding: '0 24px',
    boxSizing: 'border-box'
  }}
>
  <div
    style={{
      maxWidth: '800px',
      width: '100%',
      marginTop: '-40px' // pulls content slightly up if header exists
    }}
  >
    <h1
      style={{
        fontSize: 'clamp(2.2rem, 6vw, 4rem)',
        marginBottom: '1rem',
        fontFamily: "'Roboto Slab', serif",
        lineHeight: 1.1,
        color: 'white'
      }}
    >
      Discover The Captivating World of authentic shopping
    </h1>

    <p
      style={{
        fontSize: 'clamp(1.1rem, 2.5vw, 1.4rem)',
        marginBottom: '2rem'
      }}
    >
      Artisan products from skilled craftsmen
    </p>

    <button
      onClick={() => navigateTo('shop')}
      style={{
        background: `linear-gradient(90deg, ${theme.accent}, ${theme.accentDark})`,
        color: '#111',
        border: 'none',
        padding: '0.9rem 2.5rem',
        fontSize: '1rem',
        fontWeight: 600,
        borderRadius: '50px',
        cursor: 'pointer'
      }}
    >
      Browse Collection
    </button>
  </div>
</section>

      {/* Featured Sections */}
      <FeaturedSection
        title="Featured products"
        products={featuredBooks}
        addToCart={addToCart}
        navigateTo={navigateTo}
        bg="white"
      />

      <FeaturedSection
        title="Trending Now"
        products={featuredAccessories}
        addToCart={addToCart}
        navigateTo={navigateTo}
        bg={theme.bgLight}
      />

      {/* About Preview */}
      <AboutPreview navigateTo={navigateTo} />
    </>
  );
}